export interface BlogSummary {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  image: string;
  readTime: string;
  date: string;
  preview: string[];
  takeawayCount: number;
}

export const blogSummaries: BlogSummary[] = [
  {
    id: "1",
    title: "My Penang Learning Journey Selection 🎉",
    excerpt:
      "How I was selected for my first overseas school learning journey to Penang, Malaysia.",
    category: "Learning Journey",
    image: "/assets/images/blog/penang-learning-journey-hero.jpg",
    readTime: "5 min read",
    date: "2025",
    preview: [
      "In 2025, something really exciting happened. I was selected to go on a 4-day, 3-night overseas learning journey to Penang, Malaysia with my school.",
      "This trip was also a big personal milestone for me because it was my first time travelling overseas without my parents.",
    ],
    takeawayCount: 4,
  },
  {
    id: "2",
    title: "How I Helped My Sister Find Malware in Roblox Studio",
    excerpt:
      "A suspicious Roblox Studio pop-up taught us why free Toolbox models need careful checking.",
    category: "Online Safety",
    image: "/assets/images/blog/roblox-studio-error-501-popup.jpg",
    readTime: "4 min read",
    date: "2026",
    preview: [
      "Recently, my 7-year-old sister started using Roblox Studio. She is still learning and likes importing models from the Toolbox.",
      "One day, she inserted a Hello Kitty rug model into her game. As soon as she did that, a strange pop-up appeared saying there was an ERROR 501.",
    ],
    takeawayCount: 5,
  },
  {
    id: "3",
    title: "The Time I Tried to Sell a Time Machine (At Age 6)",
    excerpt:
      "A future-themed drawing competition somehow became my first imaginary product launch.",
    category: "Imagination",
    image: "/assets/images/blog/lespa-time-machine-drawing.jpg",
    readTime: "3 min read",
    date: "Age 6",
    preview: [
      "When I was 6 years old, I joined a small drawing competition. The theme was about the future and what we thought it would be like.",
      "Most of the other kids drew themselves in the future. My drawing was a little different. Instead of drawing myself, I drew an entire city.",
    ],
    takeawayCount: 4,
  },
  {
    id: "4",
    title: "Expand Space 2024 – A Peek Into The Future",
    excerpt:
      "A one-day Deep Tech event that made AI, VR, robotics, and space careers feel much closer.",
    category: "Future Tech",
    image: "/assets/images/blog/expand-space-2024-hero.jpg",
    readTime: "4 min read",
    date: "2024",
    preview: [
      "In November 2024, I had the opportunity to attend Expand Space, an event organised by Space Faculty.",
      "It was a one-day event, but it was packed with so many interesting things that it felt like stepping into the future.",
    ],
    takeawayCount: 4,
  },
];

export function getBlogSummary(id: string | undefined) {
  return blogSummaries.find((post) => post.id === id);
}
